import { Metadata } from '../../../../../utils/spds/metadata';
import Super from '../base.gjs';
import styles from './discovery.module.scss';

const METADATA = Metadata.define({
  description: 'Primary discovery badge indicator.',
  name: 'Discovery Primary Badge',
});

export default class SpdsIndicatorBadgeDiscoveryPrimary extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  variantClass = 'spds-indicator-badge-discovery';
  variantStyles = styles;
}

export const BADGE_DISCOVERY_PRIMARY_METADATA = SpdsIndicatorBadgeDiscoveryPrimary.metadata;
